<template>
  <mdb-modal
    :show="show"
    @close="$emit('modal-close')"
    size="lg"
    :remove-backdrop="true"
  >
    <mdb-modal-body class="p-0">
      <bridge8-google-map
        :name="`${pointType}-map-modal`"
        :point="routePoints[pointType]"
        :search-string="searchString"
        style="height: 400px; position: relative; overflow: hidden"
        :zoom="7"
        wrapperClass="z-depth-1-half"
        @pick-point="point = $event"
      />
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn
        color="info"
        size="md"
        @click.native="pickPoint()"
        :title="`Select current point as ${pointType}`"
        icon="map-marker"
      >
        Save {{ pointType }}
      </mdb-btn>
      <mdb-btn
        title="Close dialog"
        icon="times"
        outline="info"
        size="md"
        @click.native="$emit('modal-close')"
      >close</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import { RoutePointTypes } from '../enums'
import {
  mdbIcon,
  mdbBtn,
  mdbModal,
  mdbModalBody,
  mdbModalFooter
} from 'mdbvue'
import Bridge8GoogleMap from './Bridge8GoogleMap'
import { mapState } from 'vuex'
import { capitalize } from '../utils'

export default {
  name: 'CalcControlsRoutePointSelectMapModal',
  data () {
    return {
      point: {
        latitude: null,
        longitude: null,
        address: null
      }
    }
  },
  props: {
    show: Boolean,
    pointType: {
      validator: (prop) => Object.values(RoutePointTypes).includes(prop)
    },
    searchString: String
  },
  computed: {
    ...mapState('calc', {
      routePoints: state => state.query.routePoints
    }),
    capitalizedPointType: function () {
      return capitalize(this.pointType)
    }
  },
  methods: {
    pickPoint () {
      this.$emit('pick-point', this.point)
    }
  },
  components: {
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalBody,
    mdbModalFooter,
    Bridge8GoogleMap
  }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/CalcControlsRoutePointSelectMapModal.vue